export default __webpack_public_path__ + "static/ku_czerwona-ee2b16b081924c67b7b81695ffaa79ce.jpg";